export const global = Object.freeze({
	ACCESS_TOKEN: "access-token",
	USER_TOKEN: "access-user",
	TOKEN_EXPIRES: 1,
	NOTIFICATION_TIMEOUT: 5000,
	HOMEPAGE: 'formlist',
	UPLOADFOLDER: 'uploads',
	FORMPATH: 'form',
	API: 'https://www.safeformonline.com',
	// API: 'http://www.kvkk.gricreative.com',
	// API: 'http://localhost:4001',
	ENDWITH: '@gricreative.com'
})